export default __webpack_public_path__ + "static/vendor-banner-b2e7ed634369fe3143696f586a062abd.jpg";